import { render, staticRenderFns } from "./TransferDeleteModal.vue?vue&type=template&id=490cee72&scoped=true&"
import script from "./TransferDeleteModal.vue?vue&type=script&lang=js&"
export * from "./TransferDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cee72",
  null
  
)

export default component.exports